/*
 * @Description: file content
 * @Author: 
 * @Date: 2024-05-13 18:58:48
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-03-13 11:47:12
 */
import { defineStore } from 'pinia'
import Cookies from 'js-cookie'
import { getToken, removeToken, setToken } from './helper'
import { store } from '@/store'
import { setDomainToken, COWORK_DOMAIN_TOKEN_KEY } from '@/utils/domainToken'
interface SessionResponse {
  auth: boolean
  model: 'ChatGPTAPI' | 'ChatGPTUnofficialProxyAPI'
}

export interface AuthState {
  token: string | undefined
  session: SessionResponse | null
}

export const useAuthStore = defineStore('auth-store', {
  state: (): AuthState => ({
    token: getToken(),
    session: null,
  }),

  getters: {
    isChatGPTAPI(state): boolean {
      return state.session?.model === 'ChatGPTAPI'
    },
  },

  actions: {
    async getSession() {
      try {
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },

    setToken(token: string) {
      this.token = token
      setToken(token)
      setDomainToken(token, COWORK_DOMAIN_TOKEN_KEY)
    },

    removeToken() {
      this.token = undefined
      this.removeCookies()
      removeToken()
    },
    removeCookies() {
      Cookies.remove('cowork')

    },
  },
})

export function useAuthStoreWithout() {
  return useAuthStore(store)
}
